import { Component, Input } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-number-input-field',
    templateUrl: './number-input-field.component.html',
    standalone: true,
    imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, TranslateModule]
})
export class NumberInputFieldComponent {
    @Input() control: AbstractControl;
    @Input() id = '';
    @Input() min = 1;
    @Input() autocomplete = 'off';
    @Input() type = 'number';
    @Input() placeholder: string;
}
